import styled from "styled-components"

import Link, {RouterLink} from "@irati/ui/src/Link"
import {minWidthMedia} from "@irati/ui/src/global/media"
import IconText from "@irati/ui/src/IconText"

export const FailedStatusLink = styled(Link)`
  margin-left: 5px;

  ${minWidthMedia.tablet`
    margin: 0;
    display: block;
  `}
`

export const StyledRouterLink = styled(RouterLink)`
  display: inline-block;
  margin-top: 30px;

  ${minWidthMedia.tablet`
    padding-left: 35px;
    margin: 0 0 0 auto;
  `}
`

export const StyledIconText = styled(IconText)`
  & svg {
    vertical-align: baseline !important;
  }
`
